import { render, staticRenderFns } from "./vc-info.vue?vue&type=template&id=84a20712&scoped=true&"
import script from "./vc-info.vue?vue&type=script&lang=js&"
export * from "./vc-info.vue?vue&type=script&lang=js&"
import style0 from "./vc-info.vue?vue&type=style&index=0&id=84a20712&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a20712",
  null
  
)

export default component.exports